import i18next from 'i18next';

import { ApiErrorResponse } from 'types/api';

import { RESPONSE_MESSAGE_LANGUAGE_KEY_MAP } from 'constants/notifications';

export const getTranslatedResponseMessage = (
  response: ApiErrorResponse | null
): string | undefined => {
  const responseMessageString = response?.message;

  if (!responseMessageString) {
    return undefined;
  }

  const translationKey =
    RESPONSE_MESSAGE_LANGUAGE_KEY_MAP[responseMessageString];

  if (translationKey) {
    return i18next.t(translationKey);
  }

  return undefined;
};
